import React from 'react';
import {
    Box,
    Container,
    Typography,
    Card,
    CardContent,
    Grid,
    Button
} from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { TextField, Modal } from '@mui/material';
import { useState } from 'react';
import Email from '@mui/icons-material/Email';
import Phone from '@mui/icons-material/Phone';
import { db } from '../../firebase/config';
import { collection, addDoc } from 'firebase/firestore';

const Home = () => {

    const [phoneNumber, setPhoneNumber] = useState('');
    const [openSendModal, setSendOpenModal] = useState(false);
    const [openFormModal, setOpenFormModal] = useState(false);
    const [formData, setFormData] = useState({
        phone: '',
        email: ''
    });

    const handleSubmit = async () => {
        try {
            if (!phoneNumber) {
                alert('Lütfen telefon numarası giriniz.');
                return;
            }

            // Test mesajlarını da kaydet
            await addDoc(collection(db, 'testMesajlari'), {
                phoneNumber,
                gonderimTarihi: new Date(),
            });

            setSendOpenModal(true);
            setPhoneNumber('');
        } catch (error) {
            console.error('Test mesajı hatası:', error);
            alert('Test mesajı gönderilirken bir hata oluştu. Lütfen tekrar deneyiniz.');
        }
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleFormSubmit = async () => {
        try {
            // Form verilerinin validasyonu
            if (!formData.phone || !formData.email) {
                alert('Lütfen tüm alanları doldurunuz.');
                return;
            }

            // Firestore'a kaydet
            await addDoc(collection(db, 'onKayitlar'), {
                ...formData,
                kayitTarihi: new Date(),
            });

            // Modal'ı göster ve formu temizle
            setOpenFormModal(true);
            setFormData({ phone: '', email: '' });
        } catch (error) {
            console.error('Kayıt hatası:', error);
            alert('Kayıt sırasında bir hata oluştu. Lütfen tekrar deneyiniz.');
        }
    };

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        borderRadius: 2,
    };

    const packages = [
        {
            title: "Demo Paketi",
            price: "Ücretsiz",
            messages: "20 mesaj",
            features: {
                "7/24 Destek": true,
                "Raporlama": true,
                "Öncelikli Destek": false,
            }
        },
        {
            title: "Profesyonel Paket",
            price: "499₺",
            messages: "1500 mesaj",
            features: {
                "7/24 Destek": true,
                "Raporlama": true,
                "Öncelikli Destek": true,
            }
        },
        {
            title: "Kurumsal Paket",
            price: "999₺",
            messages: "4500 mesaj",
            features: {
                "7/24 Destek": true,
                "Raporlama": true,
                "Öncelikli Destek": true,
            }
        }
    ];

    const whyChooseUs = [
        {
            title: "Güvenilir Platform",
            description: "End-to-end şifreleme ile mesajlarınız güvende.",
            icon: "security"
        },
        {
            title: "Kolay Kurulum",
            description: "Saniyeler içinde kaydolabilir ve müşterilerinize hızlıca mesaj gönderemeye başlayabilirsiniz.",
            icon: "bolt"
        },
        {
            title: "Toplu Mesaj",
            description: "Tek seferde binlerce müşterinize mesaj gönderin.",
            icon: "groups"
        }
    ];

    return (
        <Box>
            {/* Hero Section */}
            <Box sx={{ bgcolor: 'primary.main', color: 'white', py: 8 }}>
                <Container maxWidth="md">
                    <Typography variant="h2" align="center" gutterBottom>
                        Ursamer
                    </Typography>
                    <Typography variant="h5" align="center" paragraph>
                        Hızlı, güvenilir ve kolay WhatsApp mesaj gönderimi
                    </Typography>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 2,
                        maxWidth: 400,
                        mx: 'auto',
                        mt: 4,
                        bgcolor: 'rgba(255, 255, 255, 0.1)',
                        p: 3,
                        borderRadius: 2
                    }}>
                        <Typography variant="h6" gutterBottom>
                            Ön Kayıt Formu
                        </Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Telefon Numarası"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            sx={{ bgcolor: 'white', borderRadius: 1 }}
                            InputProps={{
                                startAdornment: <Phone sx={{ mr: 1, color: 'text.secondary' }} />
                            }}
                        />
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="E-posta Adresi"
                            name="email"
                            type="email"
                            value={formData.email}
                            onChange={handleChange}
                            sx={{ bgcolor: 'white', borderRadius: 1 }}
                            InputProps={{
                                startAdornment: <Email sx={{ mr: 1, color: 'text.secondary' }} />
                            }}
                        />
                        <Button
                            fullWidth
                            variant="contained"
                            color="secondary"
                            size="large"
                            onClick={handleFormSubmit}
                        >
                            Ücretsiz Deneyin
                        </Button>
                    </Box>

                </Container>

                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 2,
                    maxWidth: 400,
                    mx: 'auto',
                    mt: 4,
                    p: 3,
                    borderRadius: 2
                }}>
                    <Typography variant="h6" gutterBottom>
                        Test Mesajı Gönder
                    </Typography>
                    <TextField
                        fullWidth
                        variant="outlined"
                        placeholder="Telefon Numarası"
                        name="telNumber"
                        type="tel"
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        sx={{ bgcolor: 'white', borderRadius: 1 }}
                        InputProps={{
                            startAdornment: <Phone sx={{ mr: 1, color: 'text.secondary' }} />
                        }}
                    />
                    <Button
                        fullWidth
                        variant="contained"
                        color="secondary"
                        size="large"
                        onClick={handleSubmit}
                    >
                        Test Mesajı Gönder
                    </Button>
                </Box>
            </Box>

            {/* Why Choose Us Section */}
            <Box sx={{ bgcolor: '#f5f5f5', py: 8 }}>
                <Container maxWidth="lg">
                    <Typography variant="h3" align="center" gutterBottom>
                        Neden Bizi Seçmelisiniz?
                    </Typography>
                    <Grid container spacing={4} sx={{ mt: 4 }}>
                        {whyChooseUs.map((item, index) => (
                            <Grid item key={index} xs={12} md={4}>
                                <Card
                                    sx={{
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        p: 3,
                                        textAlign: 'center'
                                    }}
                                    elevation={0}
                                >
                                    <Box
                                        sx={{
                                            width: 80,
                                            height: 80,
                                            borderRadius: '50%',
                                            bgcolor: 'primary.main',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            mb: 2
                                        }}
                                    >
                                        <span className="material-icons" style={{ color: 'white', fontSize: 40 }}>
                                            {item.icon}
                                        </span>
                                    </Box>
                                    <Typography variant="h5" gutterBottom>
                                        {item.title}
                                    </Typography>
                                    <Typography variant="body1" color="text.secondary">
                                        {item.description}
                                    </Typography>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </Box>

            {/* Packages Section */}
            <Container maxWidth="lg" sx={{ py: 8 }}>
                <Typography variant="h3" align="center" gutterBottom>
                    Paketlerimiz
                </Typography>
                <Grid container spacing={4} sx={{ mt: 4 }}>
                    {packages.map((pkg, index) => (
                        <Grid item key={index} xs={12} md={4}>
                            <Card sx={{ height: '100%' }}>
                                <CardContent>
                                    <Typography variant="h4" align="center" gutterBottom>
                                        {pkg.title}
                                    </Typography>
                                    <Typography variant="h3" align="center" color="primary" gutterBottom>
                                        {pkg.price}
                                    </Typography>
                                    <Typography variant="h6" align="center" gutterBottom>
                                        {pkg.messages}
                                    </Typography>
                                    {Object.entries(pkg.features).map(([feature, isAvailable], i) => (
                                        <Typography
                                            key={i}
                                            align="center"
                                            paragraph
                                            sx={{
                                                color: isAvailable ? 'text.primary' : 'text.disabled',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                gap: 1
                                            }}
                                        >
                                            {isAvailable ? '✓' : '✕'} {feature}
                                        </Typography>
                                    ))}
                                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                                        <Button variant="contained" color="primary">
                                            {pkg.title === "Demo Paketi" ? 'Dene' : 'Satın Al'}
                                        </Button>
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>
            <Modal
                open={openSendModal}
                onClose={() => setSendOpenModal(false)}
            >
                <Box sx={modalStyle}>
                    <Typography variant="h6" component="h2" align="center">
                        Mesaj Gönderildi!
                    </Typography>
                    <Typography align="center" sx={{ mt: 2 }}>
                        Test mesajı gönderildi!
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                        <Button variant="contained" onClick={() => setSendOpenModal(false)}>
                            Tamam
                        </Button>
                    </Box>
                </Box>
            </Modal>
            <Modal
                open={openFormModal}
                onClose={() => setOpenFormModal(false)}
            >
                <Box sx={modalStyle}>
                    <Typography variant="h6" component="h2" align="center">
                        Ön Kayıt Başarılı!
                    </Typography>
                    <Typography align="center" sx={{ mt: 2 }}>
                        En kısa sürede sizinle iletişime geçeceğiz.
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                        <Button variant="contained" onClick={() => setOpenFormModal(false)}>
                            Tamam
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </Box>
    );
};

export default Home;